export default __webpack_public_path__ + "static/media/icon_deliberacao.ecf07575.svg";